import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { getAdminUser } from '../store/AdminSlices/adminUserSlice';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { currentUser, loading } = useAppSelector((state) => state.adminUser);
  const [checkedAuth, setCheckedAuth] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const ensureProfile = async () => {
      if (currentUser || loading) {
        if (isMounted) setCheckedAuth(true);
        return;
      }
      try {
        await dispatch(getAdminUser()).unwrap();
      } catch {
        // ignore; handled by redirect below
      } finally {
        if (isMounted) setCheckedAuth(true);
      }
    };
    ensureProfile();
    return () => {
      isMounted = false;
    };
  }, [dispatch, currentUser, loading]);

  // Show loading state while checking authentication
  if (loading || !checkedAuth) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="inline-block">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // If user is not logged in, redirect to login page
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // User is authenticated, render the protected component
  return <>{children}</>;
};

export default ProtectedRoute;
